// 通用API响应接口
export type ApiSuccessResponse<T> = {
  success: true;
  message: string;
  data: T;
  time: string;
};

export type ApiErrorResponse = {
  success: false;
  message: string;
  time: string;
};

export type ApiResponse<T> = ApiSuccessResponse<T> | ApiErrorResponse;

// 分页请求接口
export interface PaginationRequest {
  page?: number;
  page_size?: number;
}

// 分页响应接口
export interface PaginationResponse<T> {
  total: number;
  page: number;
  page_size: number;
  data: T[];
}

// 通用fetch请求函数
export const fetchApi = async <T>(url: string, method: string, data?: any): Promise<ApiResponse<T>> => {
  let requestUrl = url;
  const options: RequestInit = {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // 包含cookies以支持认证
  };

  // 对于GET请求，将data作为查询参数附加到URL上
  if (method === 'GET' && data) {
    const queryParams = new URLSearchParams();
    Object.keys(data).forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        queryParams.append(key, data[key].toString());
      }
    });
    requestUrl = `${url}?${queryParams.toString()}`;
  } else if (data) {
    // 对于非GET请求，将data作为请求体发送
    options.body = JSON.stringify(data);
  }

  const response = await fetch(url, options);
  const responseData = await response.json();

  return responseData as ApiResponse<T>;
};